module.exports = wp["data"];